import { useParams } from '@tanstack/react-router';
import { CategoryForm } from './components/CategoryForm';

export function CategoryFormPage() {
  const { categoryId } = useParams({ from: '/app/inventory/categories/$categoryId' });
  const isNew = categoryId === 'new';

  return (
    <CategoryForm 
      categoryId={isNew ? undefined : categoryId} 
      isNew={isNew}
    />
  );
}
